var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex position-relative cursor-pointer",
      on: {
        click: function ($event) {
          if (
            $event.ctrlKey ||
            $event.shiftKey ||
            $event.altKey ||
            $event.metaKey
          )
            return null
          return _vm.onCardClick()
        },
      },
    },
    [
      _vm.player && _vm.embedded
        ? _c(
            "v-container",
            { staticClass: "px-1 py-2", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "d-flex align-center justify-space-between py-0",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-stretch flex-grow-1" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex rounded-lg align-end pt-1 px-1 pb-0 mr-3",
                              class: {
                                "grey lighten-3": !_vm.$vuetify.theme.dark,
                                "black lighten-3": _vm.$vuetify.theme.dark,
                              },
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  height: "100%",
                                  width: "40px",
                                  "object-fit": "cover",
                                },
                                attrs: {
                                  src:
                                    "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/" +
                                    _vm.player.playerId +
                                    ".png",
                                },
                                on: {
                                  error: function ($event) {
                                    return _vm.onImageLoadFailure(
                                      $event,
                                      "player"
                                    )
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column flex-grow-1 justify-center",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center mb-1" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "primary--text text-ellipsis mr-2 body-1 font-weight-bold",
                                      attrs: {
                                        to: `/player/${_vm.player.playerId}`,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.player.name
                                              ? _vm.player.name
                                              : _vm.player.playerName
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "monospace-font",
                                      staticStyle: { margin: "1px" },
                                      attrs: {
                                        color: _vm.getPositionChip(
                                          _vm.player.fieldPositionId
                                            ? _vm.player.fieldPositionId
                                            : _vm.player.positionId
                                        ),
                                        "text-color": "white",
                                        "x-small": "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.getPositionCode(
                                              _vm.player.fieldPositionId
                                                ? _vm.player.fieldPositionId
                                                : _vm.player.positionId
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex rounded-lg align-center",
                                      class: {
                                        "grey lighten-3":
                                          !_vm.$vuetify.theme.dark,
                                        "black lighten-3":
                                          _vm.$vuetify.theme.dark,
                                      },
                                      staticStyle: { padding: "2px 2px" },
                                    },
                                    [
                                      _vm.player.countryCode || _vm.player.cC
                                        ? _c("DriblabCountryFlag", {
                                            attrs: {
                                              iso:
                                                _vm.player.countryCode ||
                                                _vm.player.cC,
                                              scale: 0.3,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.player.age
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "body-2 primary--text ml-1",
                                        },
                                        [_vm._v(_vm._s(_vm.player.age) + "yo")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.player.teamId && _vm.showTeam
                        ? _c(
                            "div",
                            { staticClass: "ml-2" },
                            [
                              _vm.player.teamName
                                ? _c(
                                    "v-tooltip",
                                    {
                                      attrs: {
                                        bottom: "",
                                        color: "lightSecondary lighten-4",
                                        "max-width": "300",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "div",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass:
                                                          "d-inline-block",
                                                      },
                                                      "div",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        staticClass:
                                                          "nav-link d-inline-block",
                                                        attrs: {
                                                          to:
                                                            "/team/" +
                                                            _vm.player.teamId,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.ctrlKey ||
                                                              $event.shiftKey ||
                                                              $event.altKey ||
                                                              $event.metaKey
                                                            )
                                                              return null
                                                            $event.stopPropagation()
                                                            return _vm.onTeamClick()
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticStyle: {
                                                            height: "28px",
                                                            width: "28px",
                                                          },
                                                          attrs: {
                                                            src:
                                                              "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                                              _vm.player
                                                                .teamId +
                                                              ".png",
                                                          },
                                                          on: {
                                                            error: function (
                                                              $event
                                                            ) {
                                                              return _vm.onImageLoadFailure(
                                                                $event,
                                                                "team"
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1821018730
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "black--text body-1" },
                                        [_vm._v(_vm._s(_vm.player.teamName))]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.player && !_vm.embedded
        ? _c(
            "v-container",
            { staticClass: "px-1 py-0", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "pl-2 pr-0 py-1 d-flex flex-column justify-center",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-center justify-space-between",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-center justify-space-between",
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass:
                                    "primary--text text-ellipsis mr-2 body-1 font-weight-bold",
                                  attrs: {
                                    to: `/player/${_vm.player.playerId}`,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.player.name
                                        ? _vm.player.name
                                        : _vm.player.playerName
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-chip",
                                {
                                  staticClass: "monospace-font",
                                  staticStyle: { margin: "1px" },
                                  attrs: {
                                    color: _vm.getPositionChip(
                                      _vm.player.fieldPositionId
                                        ? _vm.player.fieldPositionId
                                        : _vm.player.positionId
                                    ),
                                    "text-color": "white",
                                    "x-small": "",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getPositionCode(
                                        _vm.player.fieldPositionId
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.player.secondFieldPositionId
                                ? _c(
                                    "v-chip",
                                    {
                                      staticClass: "monospace-font",
                                      staticStyle: { margin: "1px" },
                                      attrs: {
                                        color: _vm.getPositionChip(
                                          _vm.player.secondFieldPositionId
                                        ),
                                        "text-color": "white",
                                        "x-small": "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getPositionCode(
                                            _vm.player.secondFieldPositionId
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.player.teamId &&
                          _vm.player.teamName &&
                          _vm.showTeam
                            ? _c("div", { staticClass: "d-flex" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "my-1 z-3",
                                    on: {
                                      click: function ($event) {
                                        if (
                                          $event.ctrlKey ||
                                          $event.shiftKey ||
                                          $event.altKey ||
                                          $event.metaKey
                                        )
                                          return null
                                        $event.stopPropagation()
                                        return _vm.onTeamClick()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "nav-link d-flex align-center w-100",
                                        attrs: {
                                          to: "/team/" + _vm.player.teamId,
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            height: "25px",
                                            width: "25px",
                                          },
                                          attrs: {
                                            src:
                                              "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/" +
                                              _vm.player.teamId +
                                              ".png",
                                          },
                                          on: {
                                            error: function ($event) {
                                              return _vm.onImageLoadFailure(
                                                $event,
                                                "team"
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mx-2 body-2 text-ellipsis",
                                          },
                                          [_vm._v(_vm._s(_vm.player.teamName))]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showMarketValue
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "body-2 primary--text subheader-font",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("playerScout.value")) +
                                  " (" +
                                  _vm._s(_vm.currentUserCurrencySymbol) +
                                  "): " +
                                  _vm._s(
                                    _vm._f("formatCash")(
                                      _vm.player.marketValue * 1000,
                                      _vm.currentUserRate
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showInjury && _vm.isInjuried
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "body-2 primary--text subheader-font",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.player.injuryReason) +
                                  "\n          "
                              ),
                              _vm.player.injuryDateTo
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "error--text font-weight-medium",
                                    },
                                    [
                                      _vm._v(
                                        "(" +
                                          _vm._s(_vm.$t("general.until")) +
                                          " "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.player.injuryDateTo)),
                                      ]),
                                      _vm._v(")"),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.player.injuryGamesLost &&
                              !_vm.player.injuryDateTo
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "error--text font-weight-medium",
                                    },
                                    [
                                      _vm._v("("),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.player.injuryGamesLost)
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("general.gamesLost")) +
                                          ")"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSuspension && _vm.isSuspended
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "body-2 primary--text subheader-font",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.player.suspensionReason) +
                                  "\n          "
                              ),
                              _vm.player.suspensionDateTo
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "error--text font-weight-medium",
                                    },
                                    [
                                      _vm._v(
                                        "(" +
                                          _vm._s(_vm.$t("general.until")) +
                                          " "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.player.suspensionDateTo)
                                        ),
                                      ]),
                                      _vm._v(")"),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.player.suspensionGamesLost &&
                              !_vm.player.suspensionDateTo
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "error--text font-weight-medium",
                                    },
                                    [
                                      _vm._v("("),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(_vm.player.suspensionGamesLost)
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("general.gamesLost")) +
                                          ")"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }